module.exports = __webpack_public_path__ + "static/img/play_btn.cf96256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/new_years_day/play_btn.png
// module id = D+QS
// module chunks = 1